import http from '../../Services/api.laravel.http';
var qs = require('qs');

export const NavBarService = {
 	// getBrands: () => http.get('/admin/brand'),
 	getUserDetails: () => http.get('/user/details'),
}
